import { ChangeEvent, useCallback } from 'react';

import { SelectChangeEvent } from '@mui/material/Select';

export const useTransformSelectValue = <T>(
  callback: (value: T, name: string) => void
) =>
  useCallback(
    (event: SelectChangeEvent<unknown>) => {
      const name = event.target.name as string;
      callback(event.target.value as T, name);
    },
    [callback]
  );

export const useTransformInputValue = <T>(callback: (value: T) => void) =>
  useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      callback(event.target.value as T);
    },
    [callback]
  );

export const useTransformStringDatePickerValue = <T>(
  callback: (value: T) => void,
  useDate = false
) =>
  useCallback(
    (value: string | null | Date) => {
      const isDate =
        (value as any) instanceof Date && !isNaN((value as Date).getTime());

      if (!isDate) {
        return;
      }

      if (useDate) {
        if (value) {
          callback(new Date(value) as T);
        }
        return;
      }
      console.warn('do not use useTransformDatePickerValue with a string');

      if (value) {
        callback(new Date(value).toISOString() as T);
      } else {
        callback('' as T);
      }
    },
    [callback, useDate]
  );

export const useTransformCheckboxValue = (
  onChange: (checked: boolean) => void
) => {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange(checked);
    },
    [onChange]
  );
};
